import type { ServicePluginConfigType } from '@91app/dc-sdk/types'

const config: ServicePluginConfigType = {
	pluginName: 'sessionService',
	version: '1.0.0',
	main: 'main.js',
	needReplyChannel: false,
	commandChannelEvents: ['ADD_DATA_STORE_MAPPINGS']
}

export default config

